<template>
  <TwoColPageWrapper :breadcrumbs="breadcrumbs" leftBanner>
    <h1>Контакты</h1>

    <h3>
      Официальный поставщик материалов строительной химии швейцарского концерна
      Sika®
    </h3>
    <div>
      на территории Южного и Северо-Кавказского федеральных округов, республики
      Крым ООО «ШИСПАР».
    </div>
    <p></p>
    <table
      itemscope
      itemtype="http://schema.org/Organization"
      class="b-address"
    >
      <div style="display:none;" itemprop="name">Sika Краснодар</div>
      <tbody align="left">
        <tr>
          <td
            itemprop="address"
            itemscope
            itemtype="http://schema.org/PostalAddress"
            width="40%"
          >
            <span itemprop="postalCode">350039</span>,
            <span itemprop="addressLocality">г. Краснодар</span>,
            <span itemprop="streetAddress">ул. Кирпичная, 1/2</span><br />
          </td>
          <td width="10%"></td>
          <td>
            Teл.: <span itemprop="telephone">+7 (988) 312-14-14</span><br />
            <!-- Факс.: <span itemprop="faxNumber">+7 (988) 247-07-04</span
                ><br /> -->
            E-mail:
            <a href="mailto:info@shispare.ru" itemprop="email"
              >info@shispare.ru</a
            >
            ,
            <a href="mailto:shispare@yandex.ru" itemprop="email"
              >shispare@yandex.ru</a
            >
          </td>
        </tr>
      </tbody>
    </table>
    <p></p>

    <a
      href="/upload/certificates/certificate.pdf"
      target="_blank"
      class="sert-content"
      >Сертификат на поставку материалов</a
    >

    <DaYandexMap
      :zoom="17"
      :center="[45.0478, 38.85945]"
      :height="500"
      class="my-6"
    ></DaYandexMap>

    <h1>Реквизиты организации</h1>
    <table class="req-table">
      <tbody>
        <tr>
          <td>
            Название компании
          </td>
          <td>
            ООО «ШИСПАР»
          </td>
        </tr>
        <tr>
          <td>
            ОГРН
          </td>
          <td>
            1162375050991
          </td>
        </tr>
        <tr>
          <td>
            ИНН
          </td>
          <td>
            2311225890
          </td>
        </tr>
        <tr>
          <td>
            Физический адрес:
          </td>
          <td>
            350039, Краснодарский край, Краснодар г, Кирпичная ул, дом No 1/2
          </td>
        </tr>
        <tr>
          <td>
            Юридический адрес:
          </td>
          <td>
            350039, Краснодарский край, Краснодар г, Кирпичная ул, дом No 1/2
          </td>
        </tr>
      </tbody>
    </table>
  </TwoColPageWrapper>
</template>

<script>
import DaYandexMap from "~~/components/location/DaYandexMap.vue";

export default {
  components: {
    DaYandexMap,
  },
  data() {
    return {
      breadcrumbs: [
        {
          label: "Главная",
          to: { name: "main" },
        },
        {
          label: "Контакты",
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.ymap-wrap {
  height: 500px;
}

.req-table {
  margin-top: -20px;
  tr td {
    border: 1px solid rgba(85, 85, 85, 0.7);
    padding: 4px 15px;
  }
}

@media screen and (max-width: 600px) {
  .req-table {
    tr td {
      font-size: 15px;
      padding: 2px 5px;
    }
  }
}
</style>
